import React, { PropsWithChildren, useMemo } from 'react';
import { RubusUIContextData, RubusUIProvider } from '@ygtechnologies/rubus-ui';
import { useLingui } from '@lingui/react';
import { t } from '@lingui/core/macro';

interface LocalizationForwarderProps extends PropsWithChildren {}

export const LocalizationForwarder: React.FC<LocalizationForwarderProps> = ({ children }) => {
    const { i18n } = useLingui();
    const rubusUiData: RubusUIContextData = useMemo(
        () => ({
            currentLocale: i18n.locale,
            texts: {
                ShowMore: t`Show more`,
                ShowLess: t`Show less`,
                SelectAll: t`Select all`,
                Cancel: t`Cancel`,
                Confirm: t`Confirm`,
                Remove: t`Remove`,
                DragOrClickToUpload: t`Drag files or click here to upload`,
            },
            defaults: {
                modal: {
                    closeOnClickOutside: false,
                    closeOnEscape: false,
                },
            },
        }),
        [i18n.locale]
    );
    return <RubusUIProvider value={rubusUiData}>{children}</RubusUIProvider>;
};
